import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./AccordionWrapper.scss";

const AccordionWrapper = ({ children, title, id }) => {
  const uniqueId = `accordion-${id}`;

  return (
    <div className="col-12 px-0">
      {/* Bootstrap Accordion */}
      <div className="accordion" id={uniqueId}>
        <div className="accordion-item">
          <h2 className="accordion-header" id={`heading-${id}`}>
            <button
              className="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#collapse-${id}`}
              aria-expanded="false"
              aria-controls={`collapse-${id}`}
            >
              {title}
            </button>
          </h2>
          <div
            id={`collapse-${id}`}
            className="accordion-collapse collapse"
            aria-labelledby={`heading-${id}`}
            data-bs-parent={`#${uniqueId}`}
          >
            <div className="accordion-body">
              {/* Children are rendered here */}
              <div className="py-2">
                <div className="row">{children}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccordionWrapper;
